var QueryString = function () {
    var query_string = {};
    var query = window.location.search.substring(1);
    // Voor oude brouwsers support welke window.location.search niet kennen.
    if (query == "") {
        query = window.location.hash;
    }
    if (query.substring(0, 2) == "#?") {
        query = query.substring(2);
    }

    if (query.length > 0) {
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
                query_string[pair[0]] = pair[1];
                // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
                var arr = [query_string[pair[0]], pair[1]];
                query_string[pair[0]] = arr;
                // If third or later entry with this name
            } else {
                query_string[pair[0]].push(pair[1]);
            }
        }
    }

    return query_string;
}();

function updateQueryStringParameters(key, value) {
    if (value == "") {
        // No FilterValue, remove whole filter from url
        delete QueryString[key];
        return;
    }

    for (var k in QueryString) {
        if (!QueryString.hasOwnProperty(k)) continue;
        if (k == key) {
            // Check if there is a value
            if (value == "") {
                // No FilterValue, remove whole filter from url
                delete QueryString[k];
            } else {
                // There is a FilterValue, add it.
                QueryString[k] = value;
            }
            return;
        }
    }
    // Key does not exist jet. Create it.
    QueryString[key] = value;
}

/**
 * Create uri parameters form querystring object.
 *
 * @returns {string}
 * @constructor
 */
function QueryStringObjectToParameters() {
    var string = "";
    for (var k in QueryString) {
        if (!QueryString.hasOwnProperty(k)) continue;

        string += "&" + k + "=" + QueryString[k];
    }

    string = string.substr(1);
    string = "?" + string;

    return string;
}

function format_money(eur, currency_sign)
{
    if(currency_sign == false){
        return eur.toLocaleString('nl-NL', { minimumFractionDigits: 2 });
    }
    return eur.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });

}
/*
    // collapse
    */
$(function () {
    // $('[data-collapse]').each(function (i, element) {
    //     const collapse = element;

    $(document).on('click', '[data-collapse-trigger]', function () {
        const collapse =  $('[data-collapse]');
        const openedClass = $(this).closest('[data-collapse-opened-class]').data('collapse-opened-class');
        const item = $(this).closest('[data-collapse-item]');
        const content = $(this).closest('.filter-dropdown').children('[data-collapse-content]');
        // const content = item.children('[data-collapse-content]');
        const itemParents = item.parents();

        itemParents.slice(0, itemParents.index(collapse) + 1).filter('[data-collapse-item]').css('height', '');

        if (item.is('.' + openedClass)) {
            // const startHeight = content.height();

            // content.css('height', startHeight + 'px');
            item.removeClass(openedClass);
            content.removeClass(openedClass);

            // content.height(); // force reflow
            // content.css('height', '');
        } else {
            // const startHeight = content.height();

            item.addClass(openedClass);
            content.addClass(openedClass);

            // const endHeight = content.height();

            // content.css('height', startHeight + 'px');
            // content.height(); // force reflow
            // content.css('height', endHeight + 'px');
        }
        $('[data-collapse-content]', collapse).on('transitionend', function (event) {
            if (event.originalEvent.propertyName === 'height') {
                $(this).css('height', '');
            }
        });
    });


    // });
});
/*
   // mobilemenu
   */
$(function () {
    const body = $('body');
    const mobilemenu = $('.mobilemenu.menu');
    const mobilemenubutton = $('.mobile-header__menu-button');
    const mobilemenubackdrop = $('.mobilemenu.menu .mobilemenu__backdrop, .close-mobile-menu');

    const categorymenu = $('.mobilemenu.category');
    const categorymenubutton = $('.mobile-header__menu-button-category');
    const categorymenubackdrop = $('.mobilemenu.category .mobilemenu__backdrop, .close-mobile-category');

    if (mobilemenu.length) {
        const open = function(menu) {
            const bodyWidth = body.width();
            body.css('overflow', 'hidden');
            body.css('paddingRight', (body.width() - bodyWidth) + 'px');

            menu.addClass('mobilemenu--open');
        };
        const close = function(menu) {
            body.css('overflow', '');
            body.css('paddingRight', '');

            menu.removeClass('mobilemenu--open');
        };


        mobilemenubutton.on('click', function() {
            open(mobilemenu);
        });
        mobilemenubackdrop.on('click', function() {
            close(mobilemenu);
        });

        categorymenubutton.on('click', function() {
            var categoryId = $(this).data('category');
            $('.mobilemenu.category[data-category="'+categoryId+'"]').addClass('mobilemenu--open')
        });
        categorymenubackdrop.on('click', function() {
            categorymenu.removeClass('mobilemenu--open');
        });
    }
});
